import * as React        from 'react';
import { useRouteMatch } from 'react-router-dom';

import CollapseBlock      from '../../../../components/containers/CollapseBlock';
import { useInformation } from '../../../../providers/information';

import InformationCategory from '../category';

import type { InformationSectionProps } from './information.section.props';

const InformationSection: React.FC<InformationSectionProps> = function(props) {
  const match = useRouteMatch<Record<'page' | 'urlKey', string>>();

  const {
          categories,
          expandedEntries,
          isMobile,
          isObservable,
          observer,
          toggleCollapse,
        } = props;

  const information = useInformation();

  return (
    <>
      {categories.map((category) => {
        const items = expandedEntries.get(category.id) ?? new Map();

        const wrap = (children: React.ReactNode) => {
          if (!isMobile || information.type === 'questions') {
            return children;
          }

          return (
            <CollapseBlock
              key={category.id}
              label={category.label}
            >{children}</CollapseBlock>
          );
        };

        return wrap((
          <React.Fragment key={category.id}>
            {category.items.map((item) => {
              const expandedSections = items.get(item.id) ?? new Set();

              return (
                <InformationCategory
                  current={match.params.urlKey === item.urlKey}
                  data={item}
                  expandedSections={expandedSections}
                  key={`${category.id}-${item.id}`}
                  observer={observer}
                  isObservable={isObservable}
                  toggleCollapse={(item, index) => {
                    toggleCollapse(category.id, item, index);
                  }}
                />
              );
            })}
          </React.Fragment>
        ));
      })}
    </>
  );
};

export default InformationSection;